const CART_ADD = '@@Cart/ADD';
const CART_REMOVE = '@@Cart/REMOVE';
const CART_CLEAR = '@@Cart/CLEAR';

const initialState = {
	items: []
};

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {

		case CART_ADD:
			state.items.push(action.product);
			return {...state};

		case CART_REMOVE:
			return {...state};

		case CART_CLEAR:
			state.items = [];
			return {...state};
		
		default:
			return state;
	}
}

export function add(product) {
	return {
		product,
		type: CART_ADD
	};
}

export function remove(product) {
	return {
		product,
		type: CART_REMOVE
	};
}

export function clear() {
	return {
		type: CART_CLEAR
	};
}


// WEBPACK FOOTER //
// ./src/redux/modules/cart.js